// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"f0dc5356","383":"2796c22d","429":"553c4fd9","521":"65d28195","748":"fb721a9d","985":"1f00f920"}[chunkId] + ".chunk.js";
};